// extracted by mini-css-extract-plugin
export default {"spinner":"spinner---zjxt1","sk-bouncedelay":"sk-bouncedelay---rYSAA","bounce1":"bounce1---_Q2KA","bounce2":"bounce2---QZ7Ir"};